var map = {
	"./@communications/communications.module": [
		"./src/app/@features/@communications/communications.module.ts",
		"common",
		"communications-communications-module"
	],
	"./@communicationshub/communicationshub.module": [
		"./src/app/@features/@communicationshub/communicationshub.module.ts",
		"common",
		"communicationshub-communicationshub-module"
	],
	"./@events/events.module": [
		"./src/app/@features/@events/events.module.ts",
		"events-events-module"
	],
	"./@inventory/inventory.module": [
		"./src/app/@features/@inventory/inventory.module.ts",
		"inventory-inventory-module"
	],
	"./@orders/orders.module": [
		"./src/app/@features/@orders/orders.module.ts",
		"common",
		"orders-orders-module"
	],
	"./@ordersarchives/ordersarchives.module": [
		"./src/app/@features/@ordersarchives/ordersarchives.module.ts",
		"common",
		"ordersarchives-ordersarchives-module"
	],
	"./@stagedorders/stagedorders.module": [
		"./src/app/@features/@stagedorders/stagedorders.module.ts",
		"stagedorders-stagedorders-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;